import React, { forwardRef } from "react";
import Modal, { CommonModalProps, ModalContext } from "..";
import SelectableCard from "../../Cards/SelectableCard";
import ModalAsperaUpload, { ModalAsperaUploadProps } from "../ModalAsperaUpload/modal-aspera-upload";
import { ObjectClass } from "../../../Core/Api/Types/object-class";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import { Stack, Typography } from "@mui/material";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import { cacheService } from "../../../Core/Api/services";
import { useTranslation } from "react-i18next";

export type ModalChooseUploadMethodElementProps = {
  assetId: number;
  assetParentName: string;
  assetName: string;
  assetType: ObjectType;
  assetClass: ObjectClass;
  inputRef: any;
};

export type ModalChooseUploadMethodProps = CommonModalProps<ModalChooseUploadMethodElementProps>;

const ModalChooseUploadMethod = forwardRef<any, ModalChooseUploadMethodProps>((props, ref) => {
  const { assetId, assetParentName, assetName, assetType, assetClass, closeModal, inputRef } = props;
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };
  const { t } = useTranslation();

  const isCloud = cacheService.GetPlatformSettings()?.cloud ?? false;

  const handleCLickCard = (value: "http" | "aspera") => {
    if (!openModal) return;

    if (value === "http") {
      inputRef.click();
      closeModal();
    } else {
      openModal<ModalAsperaUploadProps>(ModalAsperaUpload, {
        assetParentName: assetParentName,
        assetId: assetId,
        assetName: assetName,
        assetAnnexFormatIds: [],
        assetType: assetType || ObjectType.Folder,
        assetClassification: assetClass,
        assetIsHdr: false,
        assetProviderId: 0,
        useToken: isCloud,
        closeModal: () => {},
      });
    }
  };

  return (
    <Modal closeModal={closeModal} title={t("modal:title.uploadMethod")} width={400}>
      <Stack direction={"column"} spacing={2}>
        <SelectableCard title="HTTP" key={"http"} onClick={() => handleCLickCard("http")}>
          <Stack p={2} spacing={1} direction={"column"}>
            <Typography variant="h6">{t("modal:body.uploadFilesViaHttp")}</Typography>
            <Typography sx={{ opacity: 0.75 }} variant="body2">
              {t("modal:modalChooseUploadMethod.card.http.body", {
                fileCount: GlobalConst.MAX_FILES_COUNT_HTTP,
                fileSize: GlobalConst.MAX_FILE_SIZE_HTTP_UPLOAD / 1000000000,
              })}
            </Typography>
          </Stack>
        </SelectableCard>
        <SelectableCard title={t("common:aspera")} key={"aspera"} onClick={() => handleCLickCard("aspera")}>
          <Stack p={2} spacing={1} direction={"column"}>
            <Typography variant="h6">{t("modal:modalChooseUploadMethod.card.aspera.subTitle")}</Typography>
            <Typography sx={{ opacity: 0.75 }} variant="body2">
              {t("modal:modalChooseUploadMethod.card.aspera.body")}
            </Typography>
          </Stack>
        </SelectableCard>
      </Stack>
    </Modal>
  );
});

export default ModalChooseUploadMethod;
